import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import Estate from "./Estate";
import GridConfig from "../GridConfig";
import { Header } from '../Header';
import { Footer } from '../Footer';
import EstateFlows from "./EstateFlows";

export default class Estates extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'estate',
            IsV2: true,
            data: null,
            loading: true,
            configName: 'estate_grid',
            moduleName: 'اموال',
            systemModuleId: 30,
            moduleAccessStatus: 1,
            menuId: 91
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData();
            });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Estate Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Estate Caller={this} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    onFlow(estateId,estateFlowType) {
        this.removeKeyDown();
        this.showComponents({
            component: <EstateFlows Caller={this} EstateFlowType={estateFlowType} EstateId={estateId} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "title", caption: "عنوان", show: true },
                { field: "serialnumber", caption: "سریال", show: true },
                { field: "number", caption: "شماره", show: true },
                { field: "quantity", caption: "تعداد", show: true },
                { field: "allocationQuantity", caption: "تخصیص یافته", show: true },
                { field: "exiteQuantity", caption: "خارج شده", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'title' && f.show) t.push({ field: f.field,flex:2, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.title}</a> } });
            if (f.field == 'serialnumber' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'number' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'quantity' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'allocationQuantity' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'exiteQuantity' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        t.push({
            field: "id",flex:2, headerName: "عملیات", cellRenderer: (props) => {
                return <div className="flex">
                    <a className="text-success txt-bold hand" onClick={e => this.onFlow(props.data.id, 1)}>تخصیص</a>
                    <a className="text-warning txt-bold hand" onClick={e => this.onFlow(props.data.id, 2)} style={{ "margin-right": "5px" }}>لغو تخصیص</a>
                    <a className="text-danger txt-bold hand" onClick={e => this.onFlow(props.data.id, 3)} style={{"margin-right": "5px"}} >خروج</a>
                </div>
            }
        });
        return t;
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div className="nk-content-body">
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner p-0">
                                {this.getToolBar(false)}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}